import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CancelPresentationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cancel_presentation"}/>
}
